<template>
  <!-- 业务日志 -->
  <div class="b_log">
    <!-- 列表头部栏 -->
    <r-pointer :textName="`${$t('bLog.title')}`"></r-pointer>
    <!-- 搜索模块 -->
    <r-search class="p_search" showView @on-blur="getCommValue" @on-search="commSearch(1)">
      <!-- 视图 -->
      <div slot="view">
        <label for="">{{ $t('bLog.viewText') }}：</label>
        <a-select style="width: 155px" v-model="senParams.viewId" @change="changeViewOptions">
          <a-select-option v-for="(item, index) in viewOptions" :key="index" :value="item.id">{{ item.viewName }}</a-select-option>
        </a-select>
      </div>
      <span slot="btn">
        <!-- 自定义字段 -->
        <a-tooltip placement="top" :title="`${$t('formAbout.customizeFields')}`">
          <i class="iconfont iconzidingyiziduan" @click="openAddViewModal"></i>
        </a-tooltip>
        <!-- 导出 -->
        <!-- <a-tooltip placement="top" :title="`${$t('formAbout.export')}`" style="margin: 0 10px;">
          <i class="iconfont icondaochu" @click="expoList"></i>
        </a-tooltip> -->
      </span>
      <!-- 高级搜索 -->
      <div slot="senior" id="search_form">
        <a-form :form="searchFrom" @submit="handleSearch" class="senior_form" layout="inline">
          <a-row type="flex">
            <a-col :span="7">
              <a-form-item :label="`${ $t('varRecord.colTable[1]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select v-decorator="['robotNo']" style="width:100%;">
                  <a-select-option v-for="(item, index) in robotOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item :label="`${ $t('varRecord.colTable[2]') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select v-decorator="['procName']" style="width:100%;">
                  <a-select-option v-for="(item, index) in processOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item :label="`${ $t('varRecord.colTable[4]') }`" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                <a-range-picker style="width:100%;" v-decorator="['accessTime']" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col :span="7">
              <a-form-item :wrapper-col="{ span: 16, offset: 6 }">
                <a-button type="primary" html-type="submit" :loading="searchLoading"> {{ $t('formAbout.searchBtn') }} </a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="handleReset" > {{ $t('formAbout.clear') }} </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </r-search>
    <!-- 列表数据 -->
    <a-table
      :dataSource="dataList"
      :pagination="pagination"
      :loading="tabLoading"
      :rowSelection="listSelect"
      rowKey="id"
      :scroll="{ x: ( thFieldsData.length + 1 ) * 160 }">
      <a-table-column v-for="(item, index) in thFieldsData" :dataIndex="item.fieldName" :key="item.fieldName" width="160px" class="header-box">
        <template slot-scope="text">
          <span v-if="item.fieldName == 'all'">{{ JSON.parse(text) }}</span>
          <div v-else class="flow_one" :title="text" style="width:160px;">{{ text || '-' }}</div>
        </template>
        <a-row slot="title" type="flex" justify="start" >
          <a-col :span="16">
            {{ item.displayName }}
          </a-col>
          <a-col :span="4" v-if="senParams.viewId != -1 && thFieldsData.length > 1" class="tool_tip_col">
            <a-tooltip placement="top" :title="`${$t('operation.deleteCurCol')}`">
              <i class="iconfont iconcuowu" @click="deleteCol(item.fieldName)"></i>
            </a-tooltip>
            <a-tooltip v-if="index != 0" placement="top" :title="`${$t('operation.curColTurnLeft')}`">
              <i class="iconfont iconxiangzuo" @click="turnL(item.fieldName)"></i>
            </a-tooltip>
            <a-tooltip v-if="index != thFieldsData.length - 1" placement="top" :title="`${$t('operation.curColTurnRight')}`">
              <i class="iconfont iconxiangyou" @click="turnR(item.fieldName)"></i>
            </a-tooltip>
          </a-col>
        </a-row>
      </a-table-column>
      <!-- 操作 -->
      <a-table-column
        :title="$t('operation.tableOperation')"
        key="operation"
        align="right"
        fixed="right"
        width="90px">
        <span slot-scope="record">
          <template>
            <div style="min-width:90px;">
              <a @click="handleViewDetails(record)">{{ $t('operation.viewDetails') }}</a>
              <br>
              <a @click="handleDelete(record.id)">{{ $t('operation.variateDel') }}</a>
            </div>
          </template>
        </span>
      </a-table-column>
    </a-table>
    <!-- 批量删除 -->
    <div class="btn_move" v-if="pagination.total > 0">
      <a-button @click="handleDelete()" :disabled="listSelect.selectedRowKeys.length < 1">{{ $t('operation.btnDel') }}</a-button>
    </div>
    <!-- 新增视图-弹框 -->
    <a-modal
      :title="$t('taskData.view.customField')"
      v-model="viewAddShow"
      :destroyOnClose="false"
      :footer="null"
      @cancel="cancelOption"
      width="888px">
      <!-- 保存按钮 -->
      <a-row class="save-fields" type="flex" justify="space-between">
        <!-- 视图名称-输入 -->
        <a-col :span="12">
          <label for="">{{ $t('bLog.viewN') }}：</label>
          <a-input v-model="viewName" style="width:80%;"/>
        </a-col>
        <a-button :loading="modalLoading" type="primary" @click="handleOk">{{ $t('operation.save') }}</a-button>
      </a-row>
      <!-- 所有自定义字段 -->
      <a-table :dataSource="allFieldsData" :columns="allColumns" :pagination="false" rowKey="fieldName" :scroll="{y: 555}">
        <!-- 选择 -->
        <span slot="choose" slot-scope="text, record">
          <template>
            <i :class="{iconfont: true, iconxuanze: true, 'custom-field-choose': true, active: text}" @click="chooseFields(record)"></i>
          </template>
        </span>
        <span slot="displayName" slot-scope="text, record">
          <template>
            <editable-cell :text="text" @change="onCellChange(record.fieldName, 'displayName', $event)"/>
          </template>
        </span>
      </a-table>
    </a-modal>
    <!-- 视图管理-弹框 -->
    <a-modal v-model="manageModal" :title="`${ $t('bLog.viewM') }`" width="800px" :footer="null" @cancel="delCancel">
      <a-input-search :placeholder="`${$t('formAbout.search')}`" v-model="delViewName" @search="_fetchViewList()" style="margin-bottom: 10px;width:70%;"/>
      <a-table
        :dataSource="viewList"
        :columns="viewTableColums"
        :pagination="false"
        rowKey="id"
        :scroll="{ y: 400 }"
        :rowSelection="viewSelect"></a-table>
      <!-- 删除 -->
      <div class="tab_btn" @click="delView">{{ $t('operation.btnDel') }}</div>
    </a-modal>
    <!--  -->
    <!-- 查看详情 Modal -->
    <content-view
      :m-show="showContent"
      @cancel="closeContent"
      :all-columns="contentCols"
      :all-fields-data="contentList"
      :json-data="contentJson"
      :copy="true"
      :boxed="true"></content-view>
  </div>
</template>

<script>
import { apiBLog, apiView } from '@/api/bLog'
import { apiRobot } from '@/api/robot'
import { apiProcess } from '@/api/process'

export default {
  data () {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      // 机器人下拉
      robotOptions: [],
      // 流程下拉
      processOptions: [],
      // 搜索load
      searchLoading: false,
      // 表格load
      tabLoading: false,
      // 表格表头
      thFieldsData: [],
      // 搜索表单实例
      searchFrom: this.$form.createForm(this),
      // 搜索入参
      senParams: {
        viewId: -1,
        procName: '',
        robotNo: '',
        jobNo: '',
        lucense: '',
        beginDate: '',
        endDate: ''
      },
      // 列表数据
      dataList: [],
      // 列表选中
      listSelect: {
        selectedRowKeys: [],
        onChange: (selIds, selRows) => {
          // 列表选中的id列表
          this.listSelect.selectedRowKeys = selIds
        }
      },
      // 分页
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        onChange: this.commSearch,
        onShowSizeChange: this.commSearch
      },
      // 视图列表
      viewOptions: [],
      // 自定义视图弹框 显示/隐藏
      viewAddShow: false,
      // 视图名称
      viewName: '',
      // 自定义字段
      allColumns: [
        {
          title: this.$t('taskData.view.fieldName'),
          dataIndex: 'fieldName',
          width: 150
        },
        {
          title: this.$t('taskData.view.choose'),
          dataIndex: 'choose',
          width: 80,
          scopedSlots: { customRender: 'choose' }
        },
        {
          title: this.$t('taskData.view.reference'),
          dataIndex: 'reference'
        },
        {
          title: this.$t('taskData.view.displayName'),
          dataIndex: 'displayName',
          width: 300,
          scopedSlots: { customRender: 'displayName' }
        }
      ],
      // 自定义字段表格数据
      allFieldsData: [],
      modalLoading: false,
      // 视图管理弹框-显示/隐藏
      manageModal: false,
      // 视图管理列表-除默认的
      viewList: [],
      // 视图管理表格
      viewTableColums: [
        {
          title: this.$t('bLog.viewN'),
          width: '40%',
          dataIndex: 'viewName'
        },
        {
          title: this.$t('bLog.viewT'),
          width: '50%',
          dataIndex: 'viewTime'
        }
      ],
      viewSelect: {
        selectedRowKeys: [],
        onChange: (selIds, selRows) => {
          // 视图管理选中的id列表
          this.viewSelect.selectedRowKeys = selIds
        }
      },
      // 视图管理-搜索字段
      delViewName: '',
      // 详情弹框的显示/隐藏
      showContent: false,
      // 详情，表格列
      contentCols: [
        {
          title: this.$t('taskData.view.fieldName'),
          dataIndex: 'fieldName',
          key: 'fieldName',
          width: 200
        },
        {
          title: this.$t('taskData.view.reference'),
          dataIndex: 'reference',
          key: 'reference'
        }
      ],
      contentList: [], // 详情，表格数据
      contentJson: {} // 详情，json格式数据
    }
  },
  created () {
    this._fetchViewList()
    this._fetchList()
    this._fetchSelect()
  },
  watch: {
    $route (to, from) {
      this._fetchList()
    }
  },
  methods: {
    /**
     * 获取机器人/流程 下拉数据
     */
    _fetchSelect () {
      apiRobot.list().then(data => {
        this.robotOptions = [{ value: '', label: this.$t('formAbout.all') }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: item.agentNo,
            label: item.agentAlias || item.agentNo
          }
        })
        this.robotOptions = [...this.robotOptions, ...list]
      })
      apiProcess.list().then(data => {
        this.processOptions = [{ value: '', label: this.$t('formAbout.all') }]
        if (!data.total) return
        const list = data.items.map(item => {
          return {
            value: item.procCode,
            label: item.procName || item.procCode
          }
        })
        this.processOptions = [...this.processOptions, ...list]
      })
    },
    /**
     * 获取视图列表
     */
    _fetchViewList () {
      apiView.list(this.delViewName).then(data => {
        const list = data.items.filter(value => {
          return value.id
        })
        this.viewList = list || []
        // 默认： -1,视图管理：-2
        this.viewOptions = [...list, { id: -2, viewName: this.$t('bLog.viewM') }]
        this.viewOptions.unshift({ id: -1, viewName: this.$t('bLog.defView') })
      })
    },
    /**
     * 视图切换
     */
    changeViewOptions (viewId) {
      // 打开视图管理弹框
      if (viewId === -2) {
        this.senParams.viewId = -1
        if (!this.viewList.length) {
          this.$message.error(this.$t('bLog.isChoose'))
          return
        }
        this.manageModal = true
      } else {
        this.senParams.viewId = viewId
        this.pagination.current = 1
        this._fetchList()
      }
    },
    /**
     * 获取列表数据
     */
    _fetchList () {
      this.tabLoading = true
      this.senParams.jobNo = this.$route.query.jobNo || ''
      apiBLog.list(this.senParams, this.pagination.current, this.pagination.pageSize).then(data => {
        this.tabLoading = false
        this.searchLoading = false
        this.dataList = data.data.items
        this.pagination.total = data.data.total
        this.thFieldsData = data.head.map(item => {
          return {
            fieldName: item.fieldName,
            displayName: item.displayName,
            fieldPos: ''
          }
        })
        if (!data.data.total) return
        this.setCustomFieldsData(JSON.parse(this.dataList[0].all))
      })
    },
    // 重组自定义字段表格数据
    setCustomFieldsData (initData) {
      this.allFieldsData = []
      // 已显示的表头字段数据
      Object.keys(initData).forEach(key => {
        this.allFieldsData.push({
          fieldName: key, // 显示字段
          choose: false, // 选择
          reference: initData[key], // 参考值
          displayName: '-'
        })
      })
    },
    /**
     * 获取普通搜索值
     */
    getCommValue (searchValue) {
      this.senParams.lucense = searchValue
    },
    /**
     * 普通搜索
     */
    commSearch (page, size) {
      this.pagination.current = page
      if (size) {
        this.pagination.pageSize = size
      }
      this._fetchList()
    },
    /**
     * 高级搜索
     */
    handleSearch  (e) {
      e.preventDefault()
      this.searchLoading = true
      this.searchFrom.validateFields((err, values) => {
        if (!err) {
          this.senParams.procCode = values['procName'] || ''
          this.senParams.robotNo = values['robotNo'] || ''
          const time = values['accessTime'] || []
          this.senParams.beginDate = time[0] ? time[0].format('YYYY-MM-DD') : ''
          this.senParams.endDate = time[1] ? time[1].format('YYYY-MM-DD') : ''
          this.pagination.current = 1
          this._fetchList()
        }
      })
    },
    /**
     * 高级搜索表单清空
     */
    handleReset () {
      this.searchFrom.resetFields()
    },
    /**
     * 列表删除/批量删除
     */
    handleDelete (id) {
      const _this = this
      let idStr = ''
      if (id) {
        idStr = id
      } else {
        if (!this.listSelect.selectedRowKeys.length) {
          this.$message.error(this.$t('bLog.errTip'))
          return
        }
        idStr = this.listSelect.selectedRowKeys.join(',')
      }
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('bLog.delTip'),
        okType: 'danger',
        onOk () {
          apiBLog.delete(idStr).then(data => {
            _this.$message.success(_this.$t('msg.delSuceess'))
            _this.listSelect.selectedRowKeys = []
            _this.commSearch(1)
          })
        }
      })
    },
    /**
     * 打开自定义字段弹框
     */
    openAddViewModal () {
      if (this.pagination.total === 0) {
        this.$message.error(this.$t('taskData.view.customFieldMsg'))
        return
      }
      // this.setCustomFieldsData(JSON.parse(this.dataList[0].all))
      this.viewAddShow = true
    },
    // 自定义字段选中
    chooseFields (record) {
      record.choose = !record.choose
    },
    // 单元格编辑
    onCellChange (fieldName, title, value) {
      const dataSource = [...this.allFieldsData]
      const target = dataSource.find(item => item.fieldName === fieldName)
      if (target) {
        target[title] = value
        this.allFieldsData = dataSource
      }
    },
    /**
     * 自定义字段（新增视图）
     */
    handleOk (e) {
      const newCusFields = []
      // 获取用户选中的自定义字段
      this.allFieldsData.forEach(field => {
        if (field.choose) {
          newCusFields.push({
            fieldName: field.fieldName,
            displayName: field.displayName !== '-' ? field.displayName : field.fieldName,
            fieldPos: ''
          })
        }
      })
      // 视图名必填
      if (!this.viewName) {
        this.$message.error(this.$t('bLog.errView'))
        return
      }
      // 必须有一个自定义字段
      if (!newCusFields.length) {
        this.$message.error(this.$t('bLog.requireOne'))
        return
      }
      this.modalLoading = true
      apiView.add(this.viewName, newCusFields).then(data => {
        this.modalLoading = false
        this.viewAddShow = false
        this.$message.success(this.$t('msg.addSuceess'))
        this._fetchViewList()
        this.cancelOption()
      }).catch(() => {
        this.modalLoading = false
      })
    },
    /**
     * 自定义字段-取消操作
     */
    cancelOption () {
      this.viewName = ''
      this.allFieldsData.forEach(item => {
        item.choose = false
        item.displayName = '-'
      })
    },
    /**
     * 删除当前列
     * 表格显示必须保留一个字段
     */
    deleteCol (colName) {
      let newCols = []
      if (this.thFieldsData.length > 1) {
        newCols = this.thFieldsData.filter(col => {
          return col.fieldName !== colName
        })
      } else {
        this.$message.error(this.$t('bLog.conOne'))
        return
      }
      this.reorganizationTh(newCols)
    },
    // 列左移
    turnL (colName) {
      this.controlThMovePos(colName, this.thFieldsData, 'left')
    },
    // 列右移
    turnR (colName) {
      this.controlThMovePos(colName, this.thFieldsData, 'right')
    },
    // 控制表头的移动
    controlThMovePos (colName, thData, direction) {
      // 拿到要移动的表头的索引
      const fieldIndex = this.thFieldsData.findIndex(field => field.fieldName === colName)
      // 将之前的表头数据保存到新的变量中
      const newThData = this.thFieldsData
      // 拿到要转移的表头数据
      const turnField = this.thFieldsData[fieldIndex]
      if (direction === 'right') {
        newThData[fieldIndex] = this.thFieldsData[fieldIndex + 1]
        newThData[fieldIndex + 1] = turnField
      } else {
        newThData[fieldIndex] = this.thFieldsData[fieldIndex - 1]
        newThData[fieldIndex - 1] = turnField
      }
      this.reorganizationTh(newThData)
    },
    /**
     * 重组th数据
     * 修改视图
     */
    reorganizationTh (thData) {
      apiView.edit(this.senParams.viewId, thData).then(data => {
        this.pagination.current = 1
        this._fetchList()
      })
    },
    /**
     * 视图管理-删除视图
     */
    delView () {
      // 判断是否选中视图
      if (!this.viewSelect.selectedRowKeys.length) {
        this.$message.error(this.$t('bLog.delViewCon'))
        return
      }
      const idStr = this.viewSelect.selectedRowKeys.join(',')
      const _this = this
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('bLog.delViewTip'),
        okType: 'danger',
        onOk () {
          return new Promise(resolve => {
            apiView.del(idStr).then(data => {
              _this.$message.success(_this.$t('msg.delSuceess'))
              _this._fetchViewList()
              resolve()
            }).catch(err => {
              resolve(err)
            })
          })
        }
      })
    },
    /**
     * 视图管理 - 取消操作
     */
    delCancel () {
      this.manageModal = false
      this.senParams.viewId = -1
      this.delViewName = ''
      this.viewSelect.selectedRowKeys = []
      this._fetchViewList()
    },
    // 查看详情
    handleViewDetails (row) {
      this.showContent = true
      // 初始数据
      const initData = JSON.parse(row.all)
      this.contentJson = initData
      // 初始化列表数据
      this.contentList = []
      // 组装详情表格列表数据
      Object.keys(initData).forEach(key => {
        this.contentList.push({
          fieldName: key, // 显示字段
          reference: initData[key] // 参考值
        })
      })
    },
    // 关闭详情
    closeContent () {
      this.showContent = false
    },
    // 导出 - 暂时不写
    expoList () {
      // apiBLog.export(this.senParams.viewId).then(data => {
      //   console.log(data)
      // })
    }
  }
}
</script>

<style lang="less" scoped>
.b_log {
  background: #fff;
  padding: 0 24px 12px 12px;
  .p_search {
    margin: 9px 0;
  }
  // 表头单元格操作，删除、左移、右移
  .header-box {
    .tool_tip_col:last-of-type {
      visibility: hidden;
      text-align: right;
      i {
        cursor: pointer;
        margin-left: 3px;
        &:hover {
          color: #4977FC;
        }
        &:first-of-type:hover {
          color: red;
          font-weight: bold;
        }
      }
    }
    &:hover {
      .tool_tip_col:last-of-type {
        visibility: visible;
      }
    }
  }
  /deep/.ant-table-thead > tr > th, /deep/.ant-table-tbody > tr > td {
    padding: 16px 5px;
  }
}
// 自定义字段Modal
.save-fields {
  margin-top: -14px!important;
  margin-bottom: 10px;
}
// 自定义字段表格，选择字段，字体样式
.custom-field-choose {
  color: #CCC;
  cursor: pointer;
  &.active,
  &:hover {
    color: #4977FC;
  }
}
.tab_btn {
  margin-top: 10px;
  margin-left: 30px;
  cursor: pointer;
  font-weight: bold;
}
.btn_move {
  position: relative;
  top: -50px;
  width: 75px;
}
/deep/.ant-table-header, /deep/.ant-table-body {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
.flow_one {
  overflow: hidden;
  height: 25px;
  line-height: 25px;
  text-overflow:ellipsis; //溢出用省略号显示
  white-space:nowrap;
}
</style>
